@if (loading) {
  <se-fe-spinner [seFeDataSize]="900" seFeDataCenter="center"></se-fe-spinner>
}
<se-fe-toast></se-fe-toast>
<router-outlet (activate)="onActivate($event)" (deactivate)="onDeactivate($event)"></router-outlet>
